import { Provider as UrqlProvider } from "@urql/solid"
import type { ParentProps } from "solid-js"
import { createUrqlClient } from "@/lib/urql-client"

export const urqlClient = createUrqlClient()

export function GraphQLProvider(props: ParentProps) {
  return <UrqlProvider value={urqlClient}>{props.children}</UrqlProvider>
}
